module.exports = __webpack_public_path__ + "img/169.832ee61c.jpg";